
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type UpdateBreakPayload = {
  stopId: EntityId
  breakDuration: string
}

export const updateBreakDuration = createAsyncThunk<void, UpdateBreakPayload, { state: RootState }>(
  'shiftTable/updateBreakDuration',
  async ({ stopId, breakDuration }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/updateBreakDuration' : '/runsheet/updateBreakDuration'

    await OLMSApiService.post<null>(endpoint, {
      stopId: stopId,
      breakDuration: breakDuration,
    })
  },
)
